<template>
  <drop-zone
    :allowed-extensions="allowedExtensions"
    @drop="$emit('selected', $event)"
  >
    <q-item clickable>
      <q-item-section avatar>
        <q-icon name="fa fa-upload" />
      </q-item-section>
      <q-item-section>
        {{ placeholder }}
      </q-item-section>
    </q-item>
  </drop-zone>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DropZone from './DropZone.vue';

export default defineComponent({
  emits: ['selected'],
  components: { DropZone },
  props: {
    placeholder: {
      type: String,
      default: 'Drag file here or click to upload.',
    },
    allowedExtensions: Array as () => string[],
  },
});
</script>
